<template>
  <div class="m-container">
    <div class="m-header">
      <div class="m-header-left">
        <div style="width: 80px; height: 80px;display: flex;flex-wrap: wrap;align-items: center;justify-content: center;">
          <img src="../assets/img/logo.png" width="70" height="70" alt=""/>
        </div>
        <div style="height: 70px;width: 450px;display: flex;flex-wrap: wrap;align-items: center;margin: 0 0 0 15px;">
          <div style="color: #36b9ff;font-size: 22px;height: 35px;font-weight: bold;padding-top: 5px;">
<!--            北京画梦笔信息系统科学研究院-->
            北京画梦笔信息系统科学研究院有限公司
          </div>
          <div style="height: 20px;color: #989898;">
            让世界有梦想的人不再迷茫
          </div>
        </div>
      </div>
      <div class="m-header-right" style="width: 100%;">
        <div style="display: flex;padding-left: 60px;">
          <div v-for="item in options" :key="item.id" @click="toInfoPage(item.type)" class="m-header-options"
               :class="item.type === optionIndex ? 'is-Selected' : ''">
            <div>{{item.title}}</div>
          </div>
        </div>
<!--        <div class="m-header-Hright">-->
<!--          <a href="#"><img src="../assets/img/Hguanli.png" alt=""/></a>-->
<!--          H电子管理系统-->
<!--        </div>-->
<!--        <div><a href="#">登录</a></div>-->
<!--        <div style="margin-left: 10px"><a href="#">注册</a></div>-->
      </div>
    </div>
<!--    <div class="m-banner">-->
<!--      <div class="m-banner-jie">-->
<!--        <div>-->
<!--          <a href="#"><img src="../assets/img/chubanwu.jpg" alt=""/></a>-->
<!--          <a href="#"><img src="../assets/img/hmb_yingyezhizhao.jpg" alt=""/></a>-->
<!--        </div>-->
<!--        <div>-->
<!--          <div>-->
<!--            <img src="../assets/img/bantu.jpg" alt="" style="width: 600px;height: auto;border-radius: 4px;"/>-->
<!--          </div>-->
<!--          <div style="width: 600px;">-->
<!--            你好，创业者，欢迎你来到H电子管理系统！ 「H电子管理系统」是由北京画梦笔信息系统科学研究院有限公司开发的一款针对公司内部管理系统-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div v-if="optionIndex === 'operate'" class="m-content">
<!--      <div style="display: flex;align-items: center; justify-content: center;">-->
<!--        <div style="width: 400px;">-->
<!--          <a href="#"><img src="../assets/img/chubanwu.jpg" width="400" alt=""/></a>-->
<!--        </div>-->
<!--        <div style="width: 400px;">-->
<!--          <a href="#"><img src="../assets/img/hmb_yingyezhizhao.jpg" width="400" alt=""/></a>-->
<!--        </div>-->
<!--      </div>-->
      <div style="display: flex;">
        <div class="m-content-left">
          <div class="m-content-left-tit">书籍分类</div>
          <div class="m-content-left-ul">
            <div>法律类</div>
            <div>创业类</div>
            <div>科技类</div>
            <div>历史类</div>
            <div>社科类</div>
            <div>文学类</div>
            <div>财经类</div>
            <div>管理类</div>
          </div>
        </div>
        <div class="m-content-right" style="margin-top: 40px;">
          <div class="m-content-wrap">
            <div v-for="item in dataList" :key="item.id" @click="toPage(item.id)" class="m-content-item">
              <div class="m-box-img">
                <img :src="item.img" alt="">
              </div>
              <div class="m-box-title">{{item.title}}</div>
              <div class="m-box-number">数量：{{ item.number }}</div>
              <div class="m-box-money">价格：{{ item.money }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="optionIndex === 'zixun' && isSubclass === false"  class="m-content" style="width: 1200px;margin: 30px auto;">
      <div style="display: flex;">
        <div style="flex: 1;padding-left: 20px;">
          <div class="timeline">
            <div v-for="item in zixunList" :key="item.id" class="container right">
              <div class="content">
                <h2 @click="toZiXunPage(item.id)">{{item.title}}</h2>
                <p @click="toZiXunPage(item.id)">{{ item.cont }}</p>
                <div style="display: flex; justify-content: flex-end;">
                  <div @click="openBuy" style="background-color: #9e0c0c;width: 140px;padding: 10px 0;text-align: center;color: white;border-radius: 5px;margin: 10px 0 0 0;cursor: pointer;">
                    付费查看 ￥{{ item.money }} 元
                  </div>
                </div>
              </div>
            </div>
            <!-- 更多时间节点 -->
          </div>
        </div>
        <div style="width: 300px;">
          <div class="zoom-tui">
            推荐阅读
          </div>
          <div class="zoom-box" @click="toZiXunPage(zixunList[17].id)">
            <img src="../assets/img/cover-thumb.png" alt="Sample Image" class="zoom-image">
            <div class="zoom-box-text">
              逸仙电商Q3营收6.77亿元
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isSubclass === true" class="m-content" style="width: 1300px;margin: 40px auto;">
      <div class="m-content-opt"><span @click="toInfoBack" style="cursor:pointer;">电商快讯</span> > 快讯详情</div>
      <div class="m-zx-box">
        <div>
          <div class="m-zx-fx">
            <img src="../assets/img/lianjie.png" alt="">
          </div>
          <div class="m-zx-fx">
            <img src="../assets/img/weixin.png" alt="">
          </div>
        </div>
        <div class="m-zx-cont-box">
          <div class="m-zx-cont-c">
            <div class="m-zx-title">
              {{ zixunList[listIndex].title }}
            </div>
            <div class="m-zx-len"></div>
            <div class="m-zx-cont">
              {{ zixunList[listIndex].cont }}
            </div>
            <div style="display: flex; justify-content: flex-end;">
              <div @click="openBuy" style="background-color: #9e0c0c;width: 140px;padding: 10px 0;text-align: center;color: white;border-radius: 5px;margin: 10px 0 0 0;cursor: pointer;">
                付费查看 ￥{{ zixunList[listIndex].money }} 元
              </div>
            </div>
            <div class="m-zx-tips">
              更加详细情况，请关注本站最新动态。
            </div>
          </div>
        </div>
        <div class="m-zx-right">
          <div class="m-right-head">
            <div class="m-right-h-t">电商快讯</div>
            <div class="m-right-h-r" @click="toInfoBack">
              <img src="../assets/img/right.png" alt="">
            </div>
          </div>
          <div class="timeline2">
            <div v-for="item in zixunList" :key="item.id" @click="toZiXun(item.id)" class="container2">
              <div class="content2">
                <h2>{{item.title}}</h2>
                <p>{{ item.cont }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    我院概况-->
    <div v-if="optionIndex === 'about'" class="m-content">
      <div style="text-align: center;font-weight: bold;font-size: 28px;margin-bottom: 15px;">
        画梦笔科学研究院简介
      </div>
      <div style="display: flex; align-items: center;justify-content: center;">
        <div style="display: flex; flex-wrap: wrap;justify-content: center;width: 700px;">
          <div class="m-text-tit" style="width: 100%;padding-top: 5px;">
            机构概况
          </div>
          <p class="m-text-p">
            北京画梦笔信息系统科学研究院，是中国专门从事系统科学创新研究的独立法人科研机构，地处北京市创新产业集群示范区（顺义区），下设“四部一办”，即高新技术研究部、区域经济和产业发展研究部、科研共享平台管理部，科技成果转化部和院办公室。作为中国系统科学创新研究的引导机构之一，画梦笔科研院自成立以来始终围绕现代化建设需要开展科学研究，积极落实创新驱动发展战略，为推动我国科技高质量发展肩负重大使命。
          </p>
          <p class="m-text-p">
            改革开放以来，我国一直高度重视科技进步和科技创新对国家发展的重要支撑作用，从提出“科学技术是第一生产力”的重要论断，到强调“坚持科技是第一生产力、人才是第一资源、创新是第一动力”，统筹推进科教兴国、人才强国、创新驱动三大战略；从提出“经济建设必须依靠科学技术，科学技术工作必须面向经济建设”的指导方针，到强调“坚持面向世界科技前沿、面向经济主战场、面向国家重大需求、面向人民生命健康，加快实现高水平科技自立自强”；从强调“走中国特色自主创新道路”，“建设创新型国家”到“实施创新驱动发展战略”，创新在国家现代化建设全局中的核心地位不断凸显。画梦笔科研院在这样的背景下应运而生。
          </p>
          <div class="m-text-tit" style="width: 100%;padding-top: 5px;">
            研究方向与使命
          </div>
          <p class="m-text-p">
            画梦笔科研院以系统科学为核心，开展前沿科技探索、区域经济与产业发展研究、重大科学问题攻关。落实国家创新驱动发展战略，服务现代化建设需要。推动系统科学领域的理论创新与技术进步。促进科技成果有效转化，支撑产业升级和经济发展。建设高水平科技智库，为国家及区域发展提供决策支持。深化科学技术普及，提升公众科学素养。
          </p>
          <div class="m-text-tit" style="width: 100%;padding-top: 5px;">
            核心业务
          </div>
          <p class="m-text-p">
            画梦笔科研院坚持以习近平新时代中国特色社会主义思想为指导，致力于前沿科学技术的探索研究，关注区域经济和产业发展，汇聚多领域科研人才，搭建科研共享平台，积极推动产、学、研深度化合作，促进科技成果的转化和应用，以突破重大科学问题为导向，建设高水平科技智库，深化科学技术普及，为实现科技自立自强、建设创新型国家和世界科技强国提供有力支撑。
          </p>
          <div class="m-text-tit" style="width: 100%;padding-top: 5px;">
            机构精神与理念
          </div>
          <p class="m-text-p">
            画梦笔科研院坚持弘扬“爱国、民主、科学、创新”的科研院精神，坚持“服务于国家，服务于科技”的战略方针，秉承“让世界有梦想的人不再迷茫”的价值追求，对接服务国家战略科技理论，加强高精尖产业技术研发和成果转化，落实国家人才计划和人才工程，建设高水平科研创新团队，支持高水平科技自立自强。
          </p>
          <div class="m-text-tit" style="width: 100%;padding-top: 5px;">
            发展目标与社会贡献
          </div>
          <p class="m-text-p">
            近年来，在党中央、国务院的高度重视和大力支持下，画梦笔科学研究院进入了一个新的历史发展阶段，在前沿技术研究、技术转移、创业孵化、知识产权、科技金融、科技咨询、科研成果转化等方面都取得了显著成绩，为将画梦笔科研院建设成为世界一流的科研院所奠定了坚实的基础。如今，画梦笔科研院已经成为国家培养高素质、创造性人才的摇篮、科学研究的前沿和知识创新的重要基地和国际交流的重要桥梁。
          </p>
          <p class="m-text-p">
            面向未来，画梦笔科研院将秉承初心，坚持以习近平新时代中国特色社会主义思想为指导，坚持把科技创新作为根本任务，把服务国家作为最高追求，把前沿科学技术研究作为发展根基，把深化改革作为强大动力，培养使用战略科学家，支持青年科技人才挑大梁、担重任，不断壮大科技领军人才队伍和一流创新团队，实现内涵式高质量发展，奋力迈向世界国家科研院所前列，为国家发展、人民幸福、人类文明进步作出新的更大的贡献。
          </p>
        </div>
      </div>
    </div>
<!--    项目介绍-->
    <div v-if="optionIndex === 'project'" class="m-content">
      <div style="text-align: center;font-weight: bold;font-size: 24px;margin-bottom: 15px;">
        画梦笔报告项目介绍
      </div>
      <div style="display: flex; align-items: center; justify-content: center;">
        <div style="width: 200px; height: 200px">
          <img src="../assets/img/Hguanli-2.png" width="200" height="200" alt=""/>
        </div>
      </div>
      <div style="text-align: center;margin: 10px 0 0 0;font-size: 16px">
        画梦笔报告APP
      </div>
      <div style="display: flex; flex-wrap: wrap; justify-content: center;margin: 10px 0 0 0;">
        <p class="m-text-p2">
          你好，创业者，欢迎你来到画梦笔报告！
        </p>
        <p class="m-text-p2">
          「画梦笔报告」是由北京画梦笔信息系统科学研究院研发的一款针对创业者的学习和服务类软件，在这里有关于创新研发基础科学信息，宏观创业视野，专业创业能力，顶层创业设计，前沿行业讯息，创业原理干法，防范创业风险等创业研报，让你的创业紧跟时代步伐。
        </p>
        <p class="m-text-p2">
          「画梦笔报告」创办了八大创业专栏，分别是《商业眼光》《专业创业》《创业防守》《行业秘籍》《顶层设计》《创业进攻》《摆脱迷茫》《商业情报》。
        </p>
        <p class="m-text-p2">
          【商业眼光】前沿的科技讯息，宏观的商业视角，创业的底层哲学逻辑，让创新创业者轻松洞悉商业本质。
        </p>
        <p class="m-text-p2">
          【专业创业】系统的创业理论工具包，通过通俗易懂的语言，快速获取系统的创业理论知识。
        </p>
        <p class="m-text-p2">
          【创业防守】有漏洞的创业就像是一艘有漏洞航海的船，将创业中会遇到的风险进行了总结归纳，为创新创业者保驾护航。
        </p>
        <p class="m-text-p2">
          【行业秘籍】用一篇报告看懂整个行业，通过揭开当下各行各业的升级，转型和突破方向，一同找寻新的行业发展方向。
        </p>
        <p class="m-text-p2">
          【顶层设计】营销、品牌、广告、商业模式、股权等顶层设计实操，陪伴创新创业者成为一名专业的创业设计师。
        </p>
        <p class="m-text-p2">
          【创业进攻】突破阶层就是捅破一层又一层窗户纸的过程，如何追求系统化全局的胜利。
        </p>
        <p class="m-text-p2">
          【摆脱迷茫】每个人都会遇到迷茫期，怎样摆脱人生的迷茫困境。
        </p>
        <p class="m-text-p2">
          【商业情报】第一时间获取行业资讯，紧跟行业新动向。
        </p>
      </div>
    </div>
    <!--    专家库介绍-->
    <div v-if="optionIndex === 'dean'" class="m-content">
      <div style="text-align: center;font-weight: bold;font-size: 24px;margin-bottom: 15px;">
        院长办公室简介
      </div>
      <div style="display: flex; align-items: center; justify-content: center;">
        <div style="width: 200px; height: 300px">
          <img src="../assets/img/zhuanjia1.jpg" width="200" height="300" alt=""/>
        </div>
      </div>
      <div style="text-align: center;margin: 10px 0 0 0">
        于子迪
      </div>
      <div style="display: flex;justify-content: center;">
        <div style="width: 700px;">
          <div class="m-text-tit">人物简介</div>
          <p class="m-text-p2">
            于子迪，男，北京六十甲子系统科学研究院院长，易学文化研究学者，四维立体八卦理论创始人，宏观策略研究学者，国家高级创业指导师，中国深交所执业董秘资质，中国人民解放军陆军指挥学院法律学士，西北大学经济管理学硕士。
          </p>
          <div class="m-text-tit">研究领域</div>
          <p class="m-text-p2">
            易学文化的研究与应用，宏观经济战略研究，企业战略研究，环境工程设计研究。
          </p>
          <div class="m-text-tit">学术贡献</div>
          <p class="m-text-p2">
            参与编写研究报告100余篇，主持参编著作4项，主持基础科学研究项目4项。
          </p>
          <div style="margin: 10px 0 10px 0;">
            <table>
              <tr>
                <td>画梦笔报告之专业创业研究报告（第一卷）</td>
                <td>2021年</td>
                <td>浙江电子音像出版社</td>
              </tr>
              <tr>
                <td>画梦笔报告之专业创业研究报告（第二卷）</td>
                <td>2022年</td>
                <td>浙江电子音像出版社</td>
              </tr>
              <tr>
                <td>画梦笔创业研究报告</td>
                <td>2023年</td>
                <td>广东珠江音像出版社</td>
              </tr>
              <tr>
                <td>画梦笔创业系统研究报告</td>
                <td>2023年</td>
                <td>广东珠江音像出版社</td>
              </tr>
            </table>
          </div>
          <div class="m-text-tit">所获荣誉</div>
          <p class="m-text-p2">
            2015年，入选国家资源再生利用重大示范工程项目负责人
          </p>
          <p class="m-text-p2">
            2015年，荣获伊犁州首届科学技术大会科技进步一等奖
          </p>
          <p class="m-text-p2">
            2016年，荣获伊宁市首届科学技术大会科技进步一等奖
          </p>
          <p class="m-text-p2">
            2016年，入选新疆维吾尔自治区高层次人才引进工程、全区五大创业青年人才
          </p>
          <p class="m-text-p2">
            2016年版新疆维吾尔自治区绿色建筑与再生骨料混凝土行业标准参与制定者
          </p>
          <p class="m-text-p2">
            2016年，通过深交所董秘考核认证并获得中国深交所执业董秘资质
          </p>
          <p class="m-text-p2">
            2019年，荣获国家工信部高级创业指导师职称评定
          </p>
          <p class="m-text-p2">
            2019年，国家工信部创客中国创新创业大赛特聘评委导师
          </p>
        </div>
      </div>
    </div>
    <div class="m-foot">
      <div class="m-foot-line"></div>
      <div style="margin: 20px 0 20px 0;">
        <p>北京画梦笔信息系统科学研究院有限公司</p>
        <p><a style="color: #666666" href="javascript:;">出版物经营许可证：新出发京零字第顺210027号</a></p>
        <p><a style="color: #666666" target="_black" href="http://beian.miit.gov.cn/#/Integrated/index" >增值电信业务经营许可证：京B2-20210760</a></p>
        <p><a style="color: #666666" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="baiA"> 京ICP备2021001946号-1</a></p>
        <div style="margin: 5px 0; display: flex;align-items: center;justify-content: center;">
          <div>
            <img style="width: 16px; height: 16px;display: inline-block;margin-right: 3px;" src="../assets/img/备案图标.png" alt="">
          </div>
          <div style="padding-bottom: 3px;">
            <a style="color: #666666" href="https://beian.mps.gov.cn/#/query/webSearch?code=11011302006882" rel="noreferrer" target="_blank">京公网安备11011302006882</a>
          </div>
        </div>
        <p>北京市顺义区金穗路2号院9号楼8层805</p>
      </div>
    </div>
    <el-dialog title="请扫码支付" :visible.sync="openBuyState" width="650px" center>
      <div class="m-open-container" style="margin-bottom: 40px;">
        <div style="text-align: center;">
          画梦笔订单 <span style="color: #9e0c0c; font-size: 16px; font-weight: bold;">支付金额 ￥5 元</span>
        </div>
        <div class="m-open-buy-opt">
          <div @click="selectBuyType(0)" class="m-open-buy-opt-item" :class="buyType === 0 ? 'm-open-buy-opt-at' : ''">
            <img src="../assets/img/zhifubao.gif" alt="">
            <div v-if="buyType === 0" class="m-open-buy-opt-at-tip"><i class="el-icon-s-finance"></i></div>
          </div>
          <div @click="selectBuyType(1)" class="m-open-buy-opt-item" :class="buyType === 1 ? 'm-open-buy-opt-at' : ''">
            <img src="../assets/img/weixin.gif" alt="">
            <div v-if="buyType === 1" class="m-open-buy-opt-at-tip"><i class="el-icon-s-finance"></i></div>
          </div>
        </div>
        <div class="m-open-buy-code">
          <img v-if="buyType === 0 && buyLoading === false" src="../assets/img/zfb.jpg" alt="">
          <img v-if="buyType === 1 && buyLoading === false" src="../assets/img/weixin.jpg" alt="">
          <div v-if="buyLoading" class="m-open-buy-code-load" v-loading="buyLoading"></div>
        </div>
        <div style="text-align: center;margin-top: 20px;">
          <i class="el-icon-full-screen"></i>
          打开手机扫描二维码支付
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      optionIndex: 'operate',
      dataList: [
        {id: '1', img: require('../assets/img/book1.jpg'), title: '授权', number: 99, money: 44.2},
        {id: '2', img: require('../assets/img/book2.jpg'), title: '教养在生活的细节里', number: 99, money: 59.9},
        {id: '3', img: require('../assets/img/book3.jpg'), title: '稻盛和夫语录100条', number: 99, money: 59},
        {id: '4', img: require('../assets/img/book4.jpg'), title: '传习录', number: 99, money: 52},
        {id: '5', img: require('../assets/img/book5.jpg'), title: '贫穷的本质', number: 99, money: 58},
        {id: '6', img: require('../assets/img/book6.jpg'), title: '创业从0到1', number: 99, money: 48},
        {id: '7', img: require('../assets/img/book7.jpg'), title: '细节', number: 99, money: 56.2},
        {id: '8', img: require('../assets/img/book8.jpg'), title: '内藤湖南的中国学', number: 99, money: 68},
        {id: '9', img: require('../assets/img/book9.jpg'), title: '你的格局决定你的结局', number: 99, money: 52},
        {id: '10', img: require('../assets/img/book10.jpg'), title: '华为高效工作法', number: 99, money: 64},
        {id: '11', img: require('../assets/img/book11.jpg'), title: '简单的力量', number: 99, money: 59},
        {id: '12', img: require('../assets/img/book12.jpg'), title: '组织革新', number: 99, money: 68},
        {id: '13', img: require('../assets/img/book13.jpg'), title: '碳金融市场的定价与价格运行机制研究', number: 99, money: 65.3},
        {id: '14', img: require('../assets/img/book14.jpg'), title: '零碳社会', number: 99, money: 69},
        {id: '15', img: require('../assets/img/book15.jpg'), title: '夜航船', number: 99, money: 59.8},
        {id: '16', img: require('../assets/img/book16.jpg'), title: '创业第一年要考虑的16件事', number: 99, money: 59.8},
        {id: '17', img: require('../assets/img/book17.jpg'), title: '大卖', number: 99, money: 42},
        {id: '18', img: require('../assets/img/book18.jpg'), title: '懂心理学的妈妈都很了不起', number: 99, money: 59.8}
      ],
      options: [
        {type: 'zixun', title: '行业资讯'},
        {type: 'operate', title: '出版经营'},
        {type: 'project', title: '项目介绍'},
        {type: 'about', title: '我院概况'}
        // {type: 'dean', title: '院办简介'}
      ],
      buyType: 0,
      listIndex: 0,
      isSubclass: false,
      openBuyState: false,
      buyLoading: false,
      zixunList: [
        {id: '1', money: 5, title: '马家沟芹菜盒马村挂牌仪式举办', cont: '马家沟芹菜盒马村在青岛平度市马家沟芹菜产业示范园挂牌，打霜的芹菜刚刚结束采收季，于上周登陆盒马全国400多家门店。通过几年的合作，马家沟芹菜也从刚开始上架销售的几百份，到现在基地30%以上产量都供应给盒马。而上架盒马后，马家沟芹菜也打开了零售新渠道，到现在全国有超过20家连锁商超来马家沟“要货”，而马家沟芹菜产业园也从1200亩核心区，辐射到指导周边6万多亩，带动更多农户增收。'},
        {id: '2', money: 5, title: 'Tokopedia双11家居和电子产品交易额增长近9倍', cont: 'Tokopedia和Shop Tokopedia数据显示，家居和电子产品成为今年双11促销活动中最畅销的商品类别。Tokopedia及TikTok电商通讯主管Aditia Grasio Nelwan指出，今年双11交易额增长最高的类别为杂货、电子和家居用品，平均增幅接近9倍。'},
        {id: '3', money: 5, title: '派安盈橄榄枝计划新增平台Worten', cont: 'Payoneer派安盈橄榄枝计划新增平台Worten，据悉，Worten是葡萄牙最大的电商平台之一，拥有超过230万在线商品，年销售额超过14亿欧元。'},
        {id: '4', money: 5, title: '圆通出席第十七届中国-拉美企业家高峰会', cont: '第十七届中国-拉美企业家高峰会近日在尼加拉瓜首都马那瓜的奥洛夫·帕尔梅会议中心召开。圆通速递董事长喻渭蛟在参加2024年亚太经合组织(APEC)工商领导人峰会后，受邀出席本次高峰会并作主题发言。大会期间，圆通与尼加拉瓜交通和基础设施部（MTI）签订战略合作协议，助推尼加拉瓜提升运输及物流能力。'},
        {id: '5', money: 5, title: '银联国际：Lyf旗下超1.5万家商户支持银联二维码', cont: '银联国际今日宣布，与法国头部二维码收单机构Lyf合作了后者旗下超1.5万家商户支持银联二维码。即日起，云闪付APP和境内外银联标准钱包的用户都可在当地所有开通银联二维码服务的商户扫码支付。'},
        {id: '6', money: 5, title: '知乎创始人周源：AI搜索还在比较早期的阶段', cont: '2024世界互联网大会乌镇峰会期间。知乎创始人、董事长兼首席执行官周源谈及AI搜索带来的变化时表示：“我真的认为AI搜索整体来说还在一个比较早期的阶段，不管是国内还是全球范围内，所使用的人数频次和它所能够覆盖的场景，依然还在一个比较早期的阶段。甚至包括这个词，我也没有认为它完全清楚地去描绘了产品可以做的事情。”'},
        {id: '7', money: 5, title: 'Wayfair黑五网一大促正式开启', cont: 'Wayfair宣布，黑五网一大促今日正式开启。'},
        {id: '8', money: 5, title: '苏宁易采云与清风达成战略合作', cont: '苏宁易采云近日与金红叶纸业签署战略合作协议，双方将围绕金红叶旗下清风品牌的线上渠道建设、产品开发、联合营销、物流履约等方面，展开多维深度合作，探索绿色可持续的发展模式，共同推动商用纸品采购提质增效。'},
        {id: '9', money: 5, title: '东方嘉盛：何一鸣当选为公司第六届监事会之监事会主席', cont: '深圳市东方嘉盛供应链股份有限公司于2024年11月18日召开的第六届监事会第一次会议，审议通过了《关于选举公司监事会主席的议 案》。经选举，何一鸣当选为该公司第六届监事会之监事会主席，任期自监事会审议通过之日起至第六届监事会任期届满之日止。'},
        {id: '10', money: 5, title: '雷军：向实向善是AI服务社会进步的核心要义', cont: '小米集团创始人、董事长兼首席执行官雷军在2024年世界互联网大会乌镇峰会开幕式上表示，坚持智能向实、智能向善是人工智能科技服务社会进步的核心要义，满足人们对美好科技生活的向往是创新的重点。'},
        {id: '11', money: 5, title: '美团外卖投入10亿元助力餐饮商家创新', cont: '美团日前宣布投入10亿助力金，升级餐饮“繁盛计划”，为专注产品、探索创新的餐饮商家提供更多支持，共同推动行业健康发展。这笔助力金将用于助力优质中小商家提质增效、支持餐饮产品和模式创新、加速中华老字号数字化进程，所有现金支持将从今年12月31日起分批到账。'},
        {id: '12', money: 5, title: '小米授出4959.37万股奖励股份及合共5.1亿份小米香港购股权', cont: '小米集团公告，公司于2024年11月20日根据2023年股份计划奖励合共49,593,741股奖励股份予2,425名选定参与者，包括集团雇员及服务供应商。同日，小米香港根据2024年小米香港股份计划授出合共510,335,236份小米香港购股权予2,951名为小米香港集团雇员的小米香港选定参与者。'},
        {id: '13', money: 5, title: 'DP World成为SailGP全球智能物流合作伙伴', cont: 'DP World和SailGP宣布建立开创性的全球物流合作伙伴关系，DP World成为SailGP的全球智能物流合作伙伴。此次合作为期三个赛季，DP World将为横跨五大洲的SailGP赛事提供可持续、高效的运输解决方案。双方的合作将于2024年11月23-24日在P&O Marinas主办的阿联酋迪拜帆船大奖赛上首次亮相。'},
        {id: '14', money: 5, title: '双11顺丰同城全品类日均配送单量同比增长43%', cont: '2024“双十一”大促落下帷幕，全网销售总额达14418亿元，“双十一”当日快递量达7.01亿件，创历年新高。据顺丰同城数据，“双十一”期间其全品类日均配送单量同比增长43%，其中美妆、商超便利、饮品等单量均同比增超100%。此外，顺丰同城助阵传统快递网络提速的“最后一公里”业务单量同样达成新高，其中收件场景日均单量同比增长160%。即时物流成为各路玩家升级服务、拓宽销售渠道、留存消费者的关键支撑。'},
        {id: '15', money: 5, title: '周鸿祎评华为Mate 70：全球首个软硬芯云全自研完全体', cont: '360集团创始人周鸿祎发布视频表示，华为Mate 70从头到脚全部都是创新，包括核心芯片和软件操作系统的独立自主完全自研，甚至主要的零配件几乎都100%来自于自主可控的国内供应链。“再加上华为云是独立自主的云服务和华为自己的盘古大模型，Mate 70系列‘史上最强’真正内核是全球首个软硬芯云全自研完全体。”'},
        {id: '16', money: 5, title: '新氧公布三季度财报：总收入3.718亿元', cont: '新氧公布2024年第三季度未经审计财务业绩：总收入为人民币3.718亿元，而2023年同期为人民币3.853亿元，超过了预期的高位。归属于新氧国际的净利润为人民币2030万元，而2023年同期归属于新氧国际的净利润为人民币1830万元。非美国通用会计准则下归属于新氧国际的净利润为人民币2,220万元，而2023年同期非美国通用会计准则下归属于新氧国际的净利润为人民币950万元。'},
        {id: '17', money: 5, title: '互联网电商板块短线拉升 南极电商涨停', cont: '互联网电商板块短线拉升，南极电商涨停，凯淳股份涨超14%，星徽股份、国联股份、三态股份、华鼎股份等跟涨。'},
        {id: '18', money: 5, title: '逸仙电商Q3营收6.77亿元', cont: '逸仙电商发布2024年第三季度业绩报告：总净收入较去年同期的7.181亿元人民币下降5.7%至6.77亿元人民币；毛利率从去年同期的71.4%增至75.9%；毛利润较去年同期的5.128亿元人民币增长0.2%至5.138亿元人民币；净亏损为人民币1.211亿元，而去年同期为人民币1.979亿元；非公认会计准则净亏损为人民币7660万元，而去年同期为人民币1.302亿元。'},
        {id: '19', money: 5, title: 'PingPong加入Swift体系', cont: '全球支付平台PingPong正式宣布成为环球银行金融电信协会Swift的成员。加入Swift后，PingPong可直连Swift系统，并通过其安全网络实现在全球Swift成员间的快速通信，从而进一步优化PingPong的全球支付服务网络，为企业带来更高效、更安全的跨境支付体验。'},
        {id: '20', money: 5, title: '百胜中国11月19日斥资240万美元回购5.08万股', cont: '百胜中国发布公告，于2024年11月19日该公司斥资240万美元回购5.08万股，回购价格为每股46.84-47.52港元.'},
        {id: '21', money: 5, title: '叮当健康11月20日斥资22.52万港元回购38.7万股', cont: '叮当健康发布公告，于2024年11月20日该公司斥资22.52万港元回购38.7万股，回购价格为每股0.56-0.59港元。'},
        {id: '22', money: 5, title: '阿里巴巴11月19日斥资3999.22万美元回购366.64万股', cont: '阿里巴巴-W发布公告，于2024年11月19日该公司斥资3999.22万美元回购366.64万股，回购价格为每股10.85-10.99美元。'},
        {id: '23', money: 5, title: '良品铺子：股东达永有限减持公司股份达1.13%', cont: '良品铺子公告，公司收到股东达永有限的《减持实施情况告知函》，自11月1日至11月19日，达永有限通过大宗交易方式和集中竞价方式合计减持良品铺子股份452.45万股，超过公司总股本的1%。达永有限累计减持比例为1.13%，减持后仍为公司持股5%以上股东。'},
        {id: '24', money: 5, title: '吴泳铭：通义千问API调用价格一年下降97%', cont: '2024年世界互联网大会乌镇峰会开幕。阿里巴巴集团CEO吴泳铭透露，过去一年，阿里高强度投入AI基础设施建设，基于规模效应和技术进步，算力成本持续降低。“通义千问”API调用价格一年下降97%，百万token调用花费最低已经降到了5毛钱。他认为，“就像足够便宜的电力带来电气化时代的大爆发，足够便宜的算力终将把我们带进智能化时代”。'}
      ]
    }
  },
  created () {
  },
  methods: {
    toPage (id) {
      this.$router.push({
        name: 'subclass',
        params: {
          id: id
        }
      })
    },
    toZiXun (id) {
      for (let i = 0; i < this.zixunList.length; i++) {
        if (this.zixunList[i].id === id) {
          this.listIndex = i
        }
      }
    },
    toInfoPage (type) {
      this.optionIndex = type
      this.isSubclass = false
    },
    openBuy () {
      this.openBuyState = true
    },
    toInfoBack () {
      this.isSubclass = false
    },
    toZiXunPage (id) {
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].id === id) {
          this.listIndex = i
        }
      }
      this.isSubclass = true
    },
    selectBuyType (type) {
      this.buyLoading = true
      this.buyType = type
      setTimeout(() => {
        this.buyLoading = false
      }, 1000)
    }
  },
  mounted () {
    let type = this.$route.query.type
    // console.log('123')
    // console.log(type)
    if (type !== undefined && type !== '') {
      this.optionIndex = type
    }
  }
}
</script>

<style>
/* styles.css */
body {
  font-family: Arial, sans-serif;
  margin: 40px;
}

.timeline {
  position: relative;
  width: 800px;
}

.timeline::after {
  content: '';
  position: absolute;
  width: 4px;
  background-color: #b3b3b3;
  top: 0;
  bottom: 0;
  margin-left: -3px;
}

.container {
  padding: 10px 40px;
  position: relative;
  background-color: inherit;
  width: 100%;
}

.container.left {
  left: 0;
}

.container.right {
  left: -8px;
}

.container::before {
  content: '';
  position: absolute;
  width: 15px;
  height: 15px;
  left: -1px;
  background-color: #b3b3b3;
  top: 50%;
  margin-top: -10px;
  border-radius: 50%;
  z-index: 1;
}

.content {
  text-align: left;
  padding: 10px 20px;
  border: 1px solid #b3b3b3;
  border-radius: 10px;
}

.content h2 {
  font-size: 24px;
  margin: 0;
  cursor:pointer;
  color: #333333;
}
.content h2:hover {
  color: #3a8ee6;
}

.content p {
  margin: 5px 0 0;
  cursor:pointer;
  color: #6d6d6d;
}
.content p:hover {
  color: #3a8ee6;
}

.zoom-tui {
  margin: 8px 0 0 20px;
  border-left: 4px solid #333333;
  padding: 3px 10px;
  font-weight: bold;
}

.zoom-box {
  width: 260px;
  height: 160px;
  overflow: hidden;
  border-radius: 5px;
  margin: 10px 0 0 20px;
  position: relative;
  background-color: #3a8ee6;
}

.zoom-image {
  width: 260px;
  height: 160px;
  transition: transform 0.3s ease; /* Adds smooth transition effect */
  cursor:pointer;
  filter: brightness(70%);
}

.zoom-image:hover {
  transform: scale(1.1); /* Scales the image to 110% */
}

.zoom-box-text {
  position: absolute;
  bottom: 10px;
  color: #ffffff;
  font-weight: bold;
  padding: 0 0 0 20px;
}
.m-zx-box {
  display: flex;
  padding: 15px 0 0 0;
}
.m-zx-buy {
  width: 80px;
  margin: 20px 80px 0 0;
  border: 1px solid #ff4141;
  padding: 5px 10px;
  border-radius: 3px;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.5s ease; /* 变色动画 */
}
.m-zx-buy:hover {
  background-color: #ff4141;
  color: white;
}
.m-zx-fx {
  width: 30px;
  height: 30px;
  border: 1px solid #555555;
  border-radius: 5px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: background-color 0.5s ease; /* 变色动画 */
}
.m-zx-fx img {
  width: 100%;
}
.m-zx-fx:hover {
  background-color: #d4d4d4;
}
.m-zx-cont-box {
  flex: 1;
}
.m-zx-cont-c {
  margin: 0 0 0 20px;
  border: 1px solid #666666;
  padding: 20px;
  border-radius: 10px;
}
.m-zx-title {
  font-weight: bold;
  font-size: 26px;
}
.m-zx-cont {
  margin: 15px 0 0 0;
  font-size: 20px;
}
.m-zx-len {
  margin: 15px 0 0 0;
  border-top: 1px solid #666666;
}

.m-zx-tips {
  margin-top: 40px;
  background-color: #d4d4d4;
  color: #666666;
  padding: 10px 20px;
  border-radius: 5px;
}

.m-zx-right {
  width: 320px;
  margin: 0 0 0 30px;
  box-sizing: border-box;
}
.m-right-head {
  height: 40px;
  background-color: #36b9ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.m-right-h-t {
  color: white;
  padding-left: 20px;
  font-weight: bold;
}
.m-right-h-r {
  width: 26px;
  height: 26px;
  border-radius: 26px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  border: 1px solid white;
  cursor: pointer;
  transition: background-color 0.5s ease; /* 变色动画 */
}
.m-right-h-r img {
  width: 18px;
  height: 18px;
}
.m-right-h-r:hover {
  background-color: #3a8ee6;
}

.timeline2 {
  margin-top: 5px;
  overflow: auto; /* 设置为auto，内容超出时显示滚动条 */
  position: relative;
  width: 100%;
  height: 449px;
  -ms-overflow-style: none; /* Internet Explorer和Edge浏览器 */
}

.timeline2::-webkit-scrollbar {
  width: 0;
}

.container2::after {
  content: '';
  position: absolute;
  width: 2px;
  background-color: #b3b3b3;
  top: 0;
  bottom: 0;
  left: 8px;
}

.container2 {
  padding: 0 0 20px 20px;
  position: relative;
  background-color: inherit;
  width: 100%;
  box-sizing: border-box;
}

.container2::before {
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  left: 4px;
  background-color: #b3b3b3;
  top: 50%;
  margin-top: -10px;
  border-radius: 50%;
  z-index: 1;
}

.content2 {
  width: 100%;
  height: 73px;
  text-align: left;
  padding: 10px 20px;
  border: 1px solid #b3b3b3;
  border-radius: 10px;
  box-sizing: border-box;
  cursor:pointer;
  transition: background-color 0.5s ease; /* 变色动画 */
}

.content2:hover {
  background-color: #cecece;
}

.content2 h2 {
  font-size: 14px;
  margin: 0;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.content2 p {
  font-size: 12px;
  margin: 3px 0 0 0;
  color: #6d6d6d;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue